import { RFIResponseDiscipline } from '../../../ResponseDisciplinesTableContext'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { CIMSPage } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'

export function useExpandOptions(): ExpandOptions<RFIResponseDiscipline> {
  return {
    expandable: ({ requestsForInformation }) => !!requestsForInformation.length,
    render: ({ id, requestsForInformation }) => {
      return {
        additionalInfo: [
          {
            label: "Associated RFI's",
            help: HelpMessage.RequestsForInformation.ResponseDisciplines
              .AssociatedRFIs,
            type: 'deepLinks',
            showMore: { key: id },
            links: requestsForInformation.map(
              ({ id, formattedNumber, deleted }) => ({
                label: formattedNumber,
                page: CIMSPage.RFITracker,
                deep: {
                  recordId: id,
                  deleted,
                },
              })
            ),
          },
        ],
      }
    },
  }
}
